import { Helmet } from 'react-helmet-async';
import PageBanner from '@components/Common/PageBanner';
import RightClickProtection from '@components/Common/RightClickProtection';
import './VisualizationVsReality.css';

const VisualizationVsReality = () => {
    const comparisons = [
        { id: 1, title: 'Marvel Residence', viz: '/images/viz1.jpg', real: '/images/real1.jpg' },
        { id: 2, title: 'Luxury Villa', viz: '/images/viz2.jpg', real: '/images/real2.jpg' },
        { id: 3, title: 'Modern Office', viz: '/images/viz3.jpg', real: '/images/real3.jpg' }
    ];

    return (
        <RightClickProtection>
            <Helmet>
                <title>Visualization vs Reality - AT Architects</title>
                <meta name="description" content="Compare our 3D visualizations with the actual built projects." />
            </Helmet>

            <PageBanner
                title="Visualization vs Reality"
                subtitle="Our 3D renders brought to life"
                backgroundImage="/images/comparison-banner.jpg"
            />

            <section className="comparison-section">
                <div className="comparison-container">
                    {comparisons.map(comp => (
                        <div key={comp.id} className="comparison-item">
                            <h3>{comp.title}</h3>
                            <div className="comparison-grid">
                                <div className="comparison-image">
                                    <img src={comp.viz} alt={`${comp.title} - Visualization`} />
                                    <div className="comparison-label">3D Visualization</div>
                                </div>
                                <div className="comparison-image">
                                    <img src={comp.real} alt={`${comp.title} - Reality`} />
                                    <div className="comparison-label">Built Reality</div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </RightClickProtection>
    );
};

export default VisualizationVsReality;
